import { PopoverPosition, Spinner, Tooltip } from 'construct-ui';
import _ from "lodash";
import ArrowLeft from '../../static/images/arrow-left.svg';
import loginModel from '../models/login.model';
import navigationModel from "../models/navigation/navigation.model";
import ViewBase from '../views/view-base.view';

export default function NavigationLayout() {
  ViewBase.call(this);

  const pathParentMenuIdMap = new Map();

  let dynamicMenu = [];
  let currentMenuSelection;

  let logMenu = (menuId) => {
    if (_.isEmpty(menuId)) {
      return;
    }

    navigationModel.logMenu(menuId)
      .catch(this.handleError);
  }

  let _getActiveMenuList = () => {
    _formatMenuList(navigationModel.activeMenuList);
    _buildPathParentMenuMap();
  }

  let _formatMenuList = (menu) => {
    let parentNodes = menu.filter(x => x["parentMenuID"] == "").sort((a, b) => { a["sequence"] });
    parentNodes.forEach((node) => {
      let level1 = menu.filter(x => x["parentMenuID"] == node["menuID"]);
      node["child"] = level1;
      level1.forEach((nodeLevel1) => {
        let level2 = menu.filter(x => x["parentMenuID"] == nodeLevel1["menuID"]);
        nodeLevel1["child"] = level2;
      });
      dynamicMenu.push(node);
    });
  }

  let _buildPathParentMenuMap = () => {
    // Level 1
    dynamicMenu.forEach((nodeL1) => {
      if (nodeL1.child && nodeL1.child.length > 0) {
        // Level 2
        nodeL1.child.forEach((nodeL2) => {
          if (nodeL2.child && nodeL2.child.length > 0) {
            // Level 3
            nodeL2.child.forEach((nodeL3) => {
              if (nodeL3.path) {
                pathParentMenuIdMap.set(nodeL3.path, nodeL1.menuID);
              }
            })
          } else {
            if (nodeL2.path) {
              pathParentMenuIdMap.set(nodeL2.path, nodeL1.menuID);
            }
          }
        })
      } else {
        if (nodeL1.path) {
          pathParentMenuIdMap.set(nodeL1.path, nodeL1.menuID);
        }
      }
    })
  }

  let getCurrentPath = () => { const r = m.route.get(); return r ? r.split(/([/?]){2}|[?]/g)[0] : '/'; };

  let isL1MenuSelected = (menuId) => {
    return pathParentMenuIdMap.get(getCurrentPath()) === menuId;
  }

  let isSubmenuSelected = (path) => {
    if (!path) {
      return false;
    }
    return getCurrentPath() === path;
  }

  let hasSubmenu = (menuItem) => {
    return menuItem["child"] && menuItem["child"].length > 0;
  }

  let isL1Expanded = () => {
    return !currentMenuSelection;
  };

  let isPinned = localStorage.getItem('pinMenu') === 'true'

  let togglePinMenu = () => {
    if (isPinned) {
      isPinned = false;
    } else {
      isPinned = true;
    }
    localStorage.setItem('pinMenu', isPinned)
  }

  return {
    oninit: () => {
      _getActiveMenuList();
    },
    oncreate: () => {
      const showNavbar = (toggleId, leftSide, navId, mainContainer) => {
        const toggle = document.getElementById(toggleId);
        const nav = document.getElementById(navId);
        const leftSideWidth = document.getElementById(leftSide);
        const container = document.getElementById(mainContainer);

        // Validate that all variables exist
        if (toggle && leftSide && nav && container) {
          toggle.addEventListener('click', () => {
            // show navbar
            nav.classList.toggle('show');
            toggle.classList.toggle('on');
            // main logo
            leftSideWidth.classList.toggle('collapse-lef-side');
            // add padding to body
            container.classList.toggle('body-is-open');
          });
        };
      };
      showNavbar('header-toggle', 'left-side', 'nav-bar', 'main-container');
    },
    view: () => {
      let isLoading = true;

      if (loginModel && loginModel.credentials && loginModel.credentials.country) {
        isLoading = false;
      }

      return [
        m(`.side-navbar.shadow-sm.show${isL1Expanded() ? '.expand-level-1' : ''}${isPinned ? '.pin' : ''}[id="nav-bar"]`,
          m(Spinner, {
            active: isLoading,
            background: true,
            fill: true,
            size: 'xl',
          }),
          m('.side-navbar-container',
            m('nav.nav.menu-level-1',
              // Menu Items - start
              m("ul.navbar-nav",
                dynamicMenu.map(menu => [
                  m('li',
                    m('a.nav-link', {
                      class: `${isL1MenuSelected(menu.menuID) ? 'selected' : ''} ${currentMenuSelection?.menuID === menu.menuID ? 'active' : ''}`,
                      role: 'button',
                      onclick: () => {
                        if (menu.path) {
                          this.routeTo(menu.path);
                          logMenu(menu.menuID);
                          currentMenuSelection = undefined;
                        } else {
                          // Collapse Tier-1
                          // Show sub-level menu items
                          currentMenuSelection = menu;
                        }
                      },
                    },
                      isL1Expanded()
                        ? m('span.nav-link-icon', m('i.bi', { class: menu.icon || 'bi-square' }))
                        : m(Tooltip, {
                          class: 'nav-tooltip',
                          content: menu.name,
                          hoverOpenDelay: 250,
                          inline: true,
                          openOnTriggerFocus: true,
                          position: PopoverPosition.RIGHT,
                          trigger: m('span.nav-link-icon', m('i.bi', { class: menu.icon || 'bi-square' }))
                        }),
                      m('.nav-link-title', this.getText(menu.menuID, menu.name)),
                    ),
                  ),
                ])
              )
              // Menu Items - end
            ),
            m('.menu-level-2',
              currentMenuSelection && [
                m('.d-flex.title',
                  m('.flex-fill', {
                    'role': 'button',
                    onclick: () => {
                      currentMenuSelection = undefined;
                    }
                  }, [
                    m('img.img-responsive', { "src": ArrowLeft }), currentMenuSelection.name,
                  ]),
                  m('.list-action-icon', {
                    style: {
                      zIndex: 'inherit',
                    },
                    onclick: () => { togglePinMenu() }
                  },
                    m(`i.bi.me-0.bi-pin${isPinned ? '-fill' : ''}`)
                  )),
                // Sub-menu items - start
                m('nav.nav',
                  m("ul.navbar-nav.d-flex.flex-column.gap-1",
                    currentMenuSelection?.child?.map(menuL2 => [
                      m('li',
                        m('a.nav-link', {
                          'class': isSubmenuSelected(menuL2.path) ? 'selected' : '',
                          'data-bs-toggle': hasSubmenu(menuL2) ? 'collapse' : undefined,
                          'aria-expanded': hasSubmenu(menuL2) ? 'false' : undefined,
                          'href': hasSubmenu(menuL2) && `#${menuL2.menuID}-submenus`,
                          'role': 'button',
                          onclick: () => {
                            if (!hasSubmenu(menuL2) && menuL2.path) {
                              this.routeTo(menuL2.path);
                              logMenu(menuL2.menuID);
                            }
                          },
                        },
                          menuL2.name, hasSubmenu(menuL2) && m('i.bi-chevron-right')
                        ),
                        hasSubmenu(menuL2) &&
                        m(`ul.submenus.collapse[id="${menuL2.menuID}-submenus"]`,
                          m('.nav',
                            menuL2.child.map(menuL3 => [
                              m('li',
                                m('a.nav-link', {
                                  'class': isSubmenuSelected(menuL3.path) ? 'selected' : '',
                                  'disabled': !menuL3.path,
                                  'role': 'button',
                                  onclick: () => {
                                    if (menuL3.path) {
                                      this.routeTo(menuL3.path);
                                      logMenu(menuL3.menuID);
                                    }
                                  },
                                }, menuL3.name
                                )
                              )
                            ])
                          )
                        )
                      )
                    ])
                  )
                )
                // Sub-menu items - end
              ]
            ) // .menu-level-2 - end
          ),
        ),
        this.getBaseViews()
      ];
    },
  };
}
